/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import axios from 'axios';
import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import { composeWhereClause } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import HorizontalBarChart from '../HorizontalBarChart';

function AccessByQualityRating({ height = 300 }) {
  const { stateCode } = useParams();
  const [, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const { countyCode, county } = useContext(CountyContext);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    // const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);

    async function getData() {
      // Instantiate a catalog that exists on the server
      // const catalog = new RdsCatalog(server, 'ccdc');
      // Instantiate a data product that exists on the catalog
      // const dataProduct = new RdsDataProduct(catalog, 'county_licensed_capacity');
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} 
      AND qris_participation=1 AND capacity_type=LIC`;

      whereClause += composeWhereClause({});

      if (countyCode) {
        whereClause += ` AND county_fips=${countyCode}`;
      }

      rdsTabulate('ccdc', 'county_licensed_capacity', {
        dims: 'state_fips,qris_code',
        measure: 'capacity:SUM(capacity)',
        where: whereClause,
        format: 'amcharts',
        inject: false,
      })
        .then((result) => {
          const d = _.orderBy(result.parsedBody.dataProvider, ['qris_code'], ['asc']);
          const ratingIds = d.map((v) => (v.qris_code));
          axios.get(`${process.env.REACT_APP_RDS_SERVER}/api/catalog/ccdc/county_licensed_capacity/classification/qris_code/codes?ids=${ratingIds.join(',')}`)
            .then((idsResponse) => {
              const codes = idsResponse.data;
              const total = d.reduce((a, v) => (a + Number.parseInt(v.capacity, 10)), 0);
              const payload = d.map((v) => Object.assign(v, {
                percent: ((v.capacity / total) * 100),
                qris_code: v.qris_code ? _.find(codes, { codeValue: v.qris_code }).name.replace(`${stateCode.toUpperCase()}: `, '') : 'NR',
              }));
              setData(payload);
            }).catch((getError) => {
              setError(getError);
            })
            .finally(() => {
              setReady(true);
            });
        })
        .catch((rdsError) => {
          setError(rdsError);
        })
        .finally(() => {
          setReady(true);
        });
      // setData([
      //   { groupKey: 'Infants and Toddlers', 'For married-couple families': random(30) / 100, 'For single-parent families': random(30) / 100 },
      //   { groupKey: 'Preschoolers', 'For married-couple families': random(30) / 100, 'For single-parent families': random(30) / 100 },
      // ]);
    }
    if (stateCode && states[stateCode.toUpperCase()]) {
      // fetch actual average price data
      getData();
    }
  }, [stateCode, countyCode]);

  const keys = ['capacity'];
  const groupKey = 'qris_code';

  let title = 'Program Quality Rating';
  if (county) {
    title += ` - ${county} County`;
  }

  const tooltipFormatter = function tooltipFormatter(payload) {
    return `${toFormattedNumber(payload.payload.percent)}% of programs ${payload.payload.qris_code !== 'NR' ? `have quality rating ${payload.payload.qris_code}` : ' do not report quality rating '}.`;
  };
  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <HorizontalBarChart
        height={height}
        data={data}
        tooltipFormatter={tooltipFormatter}
        valueFormatter={toFormattedNumber}
        keys={keys}
        groupKey={groupKey}
        title={title}
        colors={[primaryColor, secondaryColor]}
        showYTick
      />
    </>
  );
}

export default AccessByQualityRating;
